import React from 'react';
import { Link, withPrefix } from 'gatsby';
import * as styles from './FooterNavigationSection.module.css';
import { Link as GatsbyLink } from 'gatsby';
import Divider from '../../common_ui/Divider';
import Image from '../../common_ui/Image';

export interface NavLinkButtonProps {
  children: React.ReactNode;
  to: string;
}

const NavLinkButton: React.FC<NavLinkButtonProps> = ({ children, to }) => {
  return (
    <GatsbyLink to={to} className={styles.navButton}>
      <span className={styles.navButtonContent}>
        {children}
        <span className={styles.navButtonArrow} aria-hidden="true" >
          <Image
            src="/svg/arrow_right.svg"
            alt=""
            className={styles.navButtonArrowIcon}
          />
        </span>
      </span>
    </GatsbyLink>
  );
};

const FooterNavigationSection: React.FC = () => {
  return (
    <div className={styles.navSectionContainer}>
      <div className={styles.navSection}>
        <nav aria-label="フッターナビゲーション">
          <div className={styles.navListContainer}>
            <ul className={styles.navList}>
              <li>
                <Link to="/#about" className={styles.navLink}>
                  <span>プレコンセプションケアとは？</span>
                  <Image src="/svg/arrow_right.svg" alt="詳細へ" className={styles.arrowIcon} />
                </Link>
              </li>
              <li>
                <Link to="/manga" className={styles.navLink}>
                  <span>マンガでプレコン！</span>
                  <Image src="/svg/arrow_right.svg" alt="詳細へ" className={styles.arrowIcon} />
                </Link>
              </li>
              <li>
                <Link to="/dictionary" className={styles.navLink}>
                  <span>プレコン Dictionary</span>
                  <Image src="/svg/arrow_right.svg" alt="詳細へ" className={styles.arrowIcon} />
                </Link>
              </li>
              <li>
                <Link to="/soudan" className={styles.navLink}>
                  <span>相談窓口一覧</span>
                  <Image src="/svg/arrow_right.svg" alt="詳細へ" className={styles.arrowIcon} />
                </Link>
              </li>
            </ul>
            <ul className={styles.navList}>
              <li>
                <Link to="/event" className={styles.navLink}>
                  <span>シンポジウム・イベント情報</span>
                  <Image src="/svg/arrow_right.svg" alt="詳細へ" className={styles.arrowIcon} />
                </Link>
              </li>
              <li>
                <Link to="/contact" className={styles.navLink}>
                  <span>お問い合わせ</span>
                  <Image src="/svg/arrow_right.svg" alt="詳細へ" className={styles.arrowIcon} />
                </Link>
              </li>
              <li>
                <Link to="/privacypolicy" className={styles.navLink}>
                  <span>プライバシーポリシー</span>
                  <Image src="/svg/arrow_right.svg" alt="詳細へ" className={styles.arrowIcon} />
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.navButtonListContainer}>
            <ul className={styles.navButtonList}>
              <li>
                <NavLinkButton to="/jichitai">
                  自治体の方へ
                </NavLinkButton>
              </li>
              <li>
                <NavLinkButton to="/iryou">
                  医療機関の方へ
                </NavLinkButton>
              </li>
            </ul>
            <ul className={styles.navButtonList}>
              <li>
                <NavLinkButton to="/precon-supporter">
                  プレコンサポーターの方へ
                </NavLinkButton>
              </li>
              <Divider margin='-8px 0' className={styles.divider} />
              <li>
                <NavLinkButton to="/shizai">
                  プレコン普及啓発資材
                </NavLinkButton>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      <div className={styles.noticeSection}>
        <div className={styles.noticeText}>
          <small className={styles.noticeMark}>※</small>
          <small>
            当事業の公式SNSアカウントは、本サイトに掲載しているもののみとなります。それ以外のなりすましアカウントには十分ご注意ください
          </small>
        </div>
      </div>
    </div>
  );
};

export default FooterNavigationSection;
